import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const ContactPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Get In Touch</h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Call for appointment and start your custom tailoring journey
            </p>
          </div>
        </section>

        {/* Contact Content */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Contact Information */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-8">Contact Information</h2>

                <div className="space-y-6 mb-12">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-[#C4A962]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-[#C4A962] text-2xl"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold text-gray-900 mb-1">Visit Our Showroom</h3>
                      <a
                        href="https://maps.app.goo.gl/Qhv3cJXefy3nW8e97"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-600 hover:text-[#C4A962] transition-colors"
                      >
                        326A Washington St<br />
                        Wellesley, MA 02481
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-[#C4A962]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-[#C4A962] text-2xl"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold text-gray-900 mb-1">Call Us</h3>
                      <a
                        href="tel:781-237-3166"
                        className="text-gray-600 hover:text-[#C4A962] transition-colors"
                      >
                        781-237-3166
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-[#C4A962]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-[#C4A962] text-2xl"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold text-gray-900 mb-1">Email Us</h3>
                      <a
                        href="mailto:info@customclothiers.us"
                        className="text-gray-600 hover:text-[#C4A962] transition-colors"
                      >
                        info@customclothiers.us
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-[#C4A962]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-[#C4A962] text-2xl"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold text-gray-900 mb-1">Business Hours</h3>
                      <div className="text-gray-600">
                        <p>Monday – Friday</p>
                        <p>8:00 AM – 5:00 PM</p>
                        <p className="mt-2">Saturday</p>
                        <p>8:00 AM – 4:00 PM</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Map */}
                <div className="rounded-2xl overflow-hidden shadow-lg h-80">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11801.994221273937!2d-71.2760006!3d42.310564!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e3815826935e15%3A0xcaf824c3ab79e6a1!2sCustom%20Clothiers!5e0!3m2!1sen!2sus!4v1711556553393!5m2!1sen!2sus"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Custom Clothiers Location"
                  ></iframe>
                </div>
              </div>

              {/* Contact Form */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-8">Call for Appointment</h2>
                <BookFittingForm />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

const BookFittingForm = () => {
  return (
    <form
      action="https://readdy.ai/api/form/d6q2313a90d3mf3eg9lg"
      method="POST"
      data-readdy-form
      className="space-y-6"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label htmlFor="firstName" className="block text-sm font-semibold text-gray-900 mb-2">
            First Name *
          </label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C4A962] focus:border-transparent outline-none transition-all"
          />
        </div>
        <div>
          <label htmlFor="lastName" className="block text-sm font-semibold text-gray-900 mb-2">
            Last Name *
          </label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C4A962] focus:border-transparent outline-none transition-all"
          />
        </div>
      </div>

      <div>
        <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
          Email *
        </label>
        <input
          type="email"
          id="email"
          name="email"
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C4A962] focus:border-transparent outline-none transition-all"
        />
      </div>

      <div>
        <label htmlFor="phone" className="block text-sm font-semibold text-gray-900 mb-2">
          Phone *
        </label>
        <input
          type="tel"
          id="phone"
          name="phone"
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C4A962] focus:border-transparent outline-none transition-all"
        />
      </div>

      <div>
        <label className="block text-sm font-semibold text-gray-900 mb-3">
          I am interested in: *
        </label>
        <div className="space-y-2">
          <label className="flex items-center cursor-pointer">
            <input type="checkbox" name="interest" value="Custom Suits" className="w-5 h-5 text-[#C4A962] border-gray-300 rounded focus:ring-[#C4A962] cursor-pointer" />
            <span className="ml-3 text-gray-700">Custom Suits</span>
          </label>
          <label className="flex items-center cursor-pointer">
            <input type="checkbox" name="interest" value="Custom Shirts" className="w-5 h-5 text-[#C4A962] border-gray-300 rounded focus:ring-[#C4A962] cursor-pointer" />
            <span className="ml-3 text-gray-700">Custom Shirts</span>
          </label>
          <label className="flex items-center cursor-pointer">
            <input type="checkbox" name="interest" value="Blazers" className="w-5 h-5 text-[#C4A962] border-gray-300 rounded focus:ring-[#C4A962] cursor-pointer" />
            <span className="ml-3 text-gray-700">Blazers</span>
          </label>
          <label className="flex items-center cursor-pointer">
            <input type="checkbox" name="interest" value="Alterations" className="w-5 h-5 text-[#C4A962] border-gray-300 rounded focus:ring-[#C4A962] cursor-pointer" />
            <span className="ml-3 text-gray-700">Alterations</span>
          </label>
        </div>
      </div>

      <div>
        <label className="block text-sm font-semibold text-gray-900 mb-3">
          Appointment Type: *
        </label>
        <div className="space-y-2">
          <label className="flex items-center cursor-pointer">
            <input type="radio" name="appointmentType" value="Visit Showroom" required className="w-5 h-5 text-[#C4A962] border-gray-300 focus:ring-[#C4A962] cursor-pointer" />
            <span className="ml-3 text-gray-700">Visit Our Showroom</span>
          </label>
          <label className="flex items-center cursor-pointer">
            <input type="radio" name="appointmentType" value="House Call" className="w-5 h-5 text-[#C4A962] border-gray-300 focus:ring-[#C4A962] cursor-pointer" />
            <span className="ml-3 text-gray-700">Request House/Office Call</span>
          </label>
          <label className="flex items-center cursor-pointer">
            <input type="radio" name="appointmentType" value="Swatches" className="w-5 h-5 text-[#C4A962] border-gray-300 focus:ring-[#C4A962] cursor-pointer" />
            <span className="ml-3 text-gray-700">Get Swatches Mailed</span>
          </label>
        </div>
      </div>

      <div>
        <label htmlFor="message" className="block text-sm font-semibold text-gray-900 mb-2">
          Additional Notes
        </label>
        <textarea
          id="message"
          name="message"
          rows={4}
          maxLength={500}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C4A962] focus:border-transparent outline-none transition-all resize-none"
          placeholder="Tell us about your preferences, timeline, or any questions you have..."
        ></textarea>
        <p className="text-sm text-gray-500 mt-1">Maximum 500 characters</p>
      </div>

      <button
        type="submit"
        className="w-full bg-[#C4A962] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#B39952] transition-colors whitespace-nowrap"
      >
        <i className="ri-send-plane-line mr-2"></i>
        Submit Request
      </button>
    </form>
  );
};

export default ContactPage;